import initStore from './init-store.js';
import reducer from './reducers/index.js';

const store = initStore(reducer);

// NOTE: leave this here. It's incredibly useful for debugging infinite loops,
// as redux dev tools extension will not show which actions are firing when
// stuck in a loop

// const next = store.dispatch;
// store.dispatch = function dispatchAndLog(action) {
//   console.log('dispatching', action);
//   const result = next(action);
//   console.log('next state', store.getState());
//   return result;
// };

window.store = store;

// Get the type of our store variable
export type AppStore = typeof store;

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<AppStore['getState']>;
export type AppDispatch = AppStore['dispatch'];

export default store;
